module.exports = __webpack_public_path__ + "static/media/logo-black.2982e069.png";